import { Box } from '@mui/material'
import { postCloumnsOrderForPreview } from '../../../services/entityServices'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    Applications,
    publicShipmentView,
    URLSearchParamsKeys,
    UserPermissions,
} from '../../../constants/constants'
import { useSearchParams } from 'react-router-dom'
import {
    getEntityPreviewColumnsOrder,
    updateColumnsOrder,
} from '../../../redux/slices/entityViewSlice'
import { useMemo } from 'react'
import { ColumnOrderListType } from '../../../redux/slices/entitySlice'
import ColumnsArrangement from '../../Common/ColumnsArrangement'
import { updateLoader } from '../../../redux/slices/loaderSlice'

const PreviewColumnsArrangement: React.FC = () => {
    const [searchParams] = useSearchParams()

    const dispatch = useAppDispatch()

    const permissions = useAppSelector((state) => state.org.permissions)
    const org = useAppSelector((state) => state.org.org)
    const isAdmin = useMemo(
        () =>
            permissions.includes(UserPermissions.ORG_ADMIN) ||
            permissions.includes(UserPermissions.USER_ADMIN),
        [permissions],
    )
    const isGuestUser =
        useAppSelector((state) => state.searchParams.isGuestUser) === 'true'
    const publicSearchTemplateId = useAppSelector(
        (state) => state.searchParams.templateId,
    )
    const publicSearchOrgId = useAppSelector(
        (state) => state.searchParams.orgId,
    )
    const isPublicShipmentPreView =
        useAppSelector((state) => state.searchParams.publicShipmentView) ===
        publicShipmentView.SHIPMENT_PREVIEW

    const orgId = isPublicShipmentPreView
        ? publicSearchOrgId || ''
        : org?.id || ''
    const entityTemplateId =
        (isPublicShipmentPreView
            ? publicSearchTemplateId
            : searchParams.get(URLSearchParamsKeys.templateId)) || ''

    const applicationId =
        searchParams.get(URLSearchParamsKeys.applicationId) || ''
    const isDeviceManagerView = useMemo(
        () => applicationId === Applications.deviceManager.id,
        [applicationId],
    )

    const columnVisibilityList = useAppSelector(
        (state) => state.entityInstanceView.columnsOrder,
    )

    // Mirror the listing page restriction: entityStatus column is only shown in
    // Device Manager. Filter it out of the preview column picker for all other views.
    const filteredColumnsList = useMemo(
        () =>
            isDeviceManagerView
                ? columnVisibilityList.map((col) => {
                      if (col.attributeName === 'entityStatus') {
                          return {
                              ...col,
                              columnName: 'Device Status',
                              name: 'Device Status',
                          }
                      } else {
                          return col
                      }
                  })
                : columnVisibilityList.filter(
                      (col) => col.attributeName !== 'entityStatus',
                  ),
        [columnVisibilityList, isDeviceManagerView],
    )

    // handling column arrangmet
    const handleUpdateColumnOrder = (columnsList: ColumnOrderListType[]) => {
        dispatch(updateColumnsOrder(columnsList))
    }

    const handleResetColumnOrder = () => {
        dispatch(
            getEntityPreviewColumnsOrder({
                entityTemplateId,
                orgId,
                isGuestUser,
                isAdmin,
            }),
        )
    }

    const handleSaveColumnOrder = async () => {
        const columnsToSave = columnVisibilityList.map((col) => ({
            attributeName: col.id,
            isDisplayable: col.selected,
        }))
        dispatch(updateLoader(true))
        await postCloumnsOrderForPreview(
            entityTemplateId,
            orgId,
            columnsToSave,
            isGuestUser,
        )
        dispatch(updateLoader(false))
    }

    return (
        <Box>
            <ColumnsArrangement
                orgId={orgId}
                templateId={entityTemplateId}
                isAdmin={isAdmin}
                isGuestUser={false}
                keywordForLocalStorage="preview"
                columnsList={filteredColumnsList}
                handleUpdateColumnOrder={handleUpdateColumnOrder}
                handleResetColumnOrder={handleResetColumnOrder}
                handleSaveColumnOrder={handleSaveColumnOrder}
                isRightSide={true}
            />
        </Box>
    )
}
export default PreviewColumnsArrangement
